module.exports = __webpack_public_path__ + "static/img/Mark-Carroll.d1ef23c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mark-Carroll.jpg
// module id = 1vkh
// module chunks = 0